import React from 'react'
import Form from 'react-bootstrap/Form'

const CheckBox = ({ checked, text, onChange, classNameParent, ...props }) => {
  const handleChangeChecked = e => {
    onChange(e)
  }

  return <div className={classNameParent}>
    <Form.Check
      {...props}
      custom
      label={text}
      onChange={handleChangeChecked}
      checked={checked}
    />
  </div>
}

CheckBox.defaultProps = {
  disabled: false,
  classNameParent: 'col-12',
  onChange: () => { },
  required: false,
  text: ''
}

export default CheckBox